/** @format */

import { defineStore, type StoreDefinition } from 'pinia';
import { type FieldsType } from '../types';
import { deepClone } from '../utils/util';
import { useDragStoreWithOut } from './index';
import { store } from '@/store';

const defaultValue = () => ({
	maxLength: 20,
	index: 0,
	historyList: [] as FieldsType[][],
});

const useHistoryStore = (name?: string): StoreDefinition =>
	defineStore({
		id: name ? `${name}-histroy` : 'pc-form-designer-history',

		state: () => defaultValue(),

		actions: {
			push(record: FieldsType[]): void {
				// 新增从当前位置新增，去掉后边所有
				this.historyList = [...this.historyList.slice(0, this.index + 1), deepClone(record)];

				if (this.index === this.maxLength - 1) {
					this.historyList.unshift();
				}

				this.index = this.historyList.length - 1;
			},

			/**
			 * @description: 判断是否可撤销
			 * @return {boolean}
			 */
			isUndo(): boolean {
				return !(this.index === 0);
			},

			/**
			 * @description: 判断是否可重做
			 * @return {boolean}
			 */
			isRedo(): boolean {
				return !!this.historyList.length && this.index < this.historyList.length - 1;
			},

			/**
			 * @description: 撤销操作
			 * @param {*}
			 * @return {T}
			 */
			undo(): FieldsType[] | false {
				// 没有记录时,返回false
				if (!this.isUndo()) {
					return false;
				}
				this.index--;
				const record = deepClone(this.historyList[this.index]);

				const dragStore = useDragStoreWithOut(name);
				dragStore.setState({ widgetDatas: record });
				dragStore.setState({ selectField: null });
				return record;
			},

			/**
			 * @description: 重做操作
			 * @param {*}
			 * @return {*}
			 */
			redo(): FieldsType[] | false {
				if (!this.isRedo()) {
					return false;
				}
				this.index++;
				const record = deepClone(this.historyList[this.index]);

				const dragStore = useDragStoreWithOut(name);
				dragStore.setState({ widgetDatas: record });
				dragStore.setState({ selectField: null });
				return record;
			},
		},
	});

export function useHistoryStoreWithOut(name?: string): any {
	return useHistoryStore(name)(store);
}
